import { formatDateKanji } from '@/util/common'
import * as _ from 'lodash'
import * as moment from 'moment'

export const ServiceLicenseCancelInputComplete = (props, context) => {
  const store = context.root.$store
  const { cancellation: { cancellationList } } = store.state

  const basicProduct = (_pack) => _.filter(_pack.product_lists, product => product.classification === 2)
  const isBasicCanceled = (_pack) => basicProduct(_pack).length > 0 && _.every(basicProduct(_pack), product => product.total_license_number <= product.license_number)
  const optionProduct = (_pack) => _.filter(_pack.product_lists, product => product.classification === 3)

  const close = () => {
    context.emit('closeViewComplete')
  }

  // ライセンス終了日の翌日を算出
  const endDate = (date) => {
    return formatDateKanji(moment(date).add(1, 'days'))
  }

  return {
    close,
    cancellationList,
    formatDateKanji,
    basicProduct,
    optionProduct,
    isBasicCanceled,
    endDate
  }
}
